// @see mylw-lwdev.nexcess-internal.workers.dev
import devTemplate from './dev';
import type { AppConfigI } from './example';

const lwdev: AppConfigI = devTemplate;

export default lwdev;
